import { getImage } from "../../../services/image-utils";
import Title from "antd/es/typography/Title";
import Text from "antd/es/typography/Text";
import { Image } from "antd";

const noData = (type: boolean, order?: boolean) => {
  const noData = getImage("/assets/no-data.png");
  const noFilters = getImage("/assets/no-filters.png");
  const noStudents = getImage("/assets/no-students.png");

  return (
    <>
      {type ? (
        <div className="no-data-wrapper">
          <Image width={300} preview={false} src={noData} />
          <div className="flex flex-col justify-center pb-8 items-center">
            <div>
              <Title level={4}>No data found</Title>
            </div>
            <Text>
              The filters that you applied is not retuning data for this
              section.
            </Text>
          </div>
        </div>
      ) : (
        <div className="flex flex-1 justify-between">
          {!order && (
            <div className="max-w-xl pl-16">
              <Title level={4} style={{ fontWeight: 300 }}>
                To get started, please select a student from whom you would like
                to retrieve information. You can then begin analyzing the data
                related to your chosen student.
              </Title>
            </div>
          )}
          <Image
            width={450}
            preview={false}
            src={order ? noFilters : noStudents}
            style={{ paddingTop: !order ? "10rem" : undefined }}
          />
          {order && (
            <div className="max-w-xl pr-16">
              <Title level={4} style={{ fontWeight: 300 }}>
                To work with this section, please select the courses from which
                you would like to retrieve information. You can then begin
                analyzing the data based on your selected courses.
              </Title>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default noData;
